<mat-card>
  <mat-card-title>
    {{calendarData.summary}}
  </mat-card-title>
  <mat-card-subtitle *ngIf="calendarData.description">{{calendarData.description}}</mat-card-subtitle>
  <mat-card-content>
    <h2 mat-line>Permissos</h2>
    <p mat-line>
      {{localizeACL(calendarData.accessRole)}}
    </p>
    <mat-divider></mat-divider>
    <h3 mat-line>Subscripcions</h3>
    <p mat-line>
      <mat-checkbox style="margin-right: 1em;"
        name="follow"
        [ngModel]="subscriptions.dashboard"
        (ngModelChange)="updateSubscription('dashboard', $event)">
          Seguir
      </mat-checkbox>
      <mat-checkbox style="margin-right: 1em;"
        name="agenda"
        [ngModel]="subscriptions.agenda"
        (ngModelChange)="updateSubscription('agenda', $event)">
          Agenda
      </mat-checkbox>
      <mat-checkbox style="margin-right: 1em;"
        name="creation"
        [ngModel]="subscriptions.eventCreation"
        (ngModelChange)="updateSubscription('eventCreation', $event)">
          Nou events
      </mat-checkbox>
      <mat-checkbox style="margin-right: 1em;"
        name="follow"
        [ngModel]="subscriptions.eventChange"
        (ngModelChange)="updateSubscription('eventChange', $event)">
          Canvis
      </mat-checkbox>
      <mat-checkbox style="margin-right: 1em;"
        name="follow"
        [ngModel]="subscriptions.eventCancellation"
        (ngModelChange)="updateSubscription('eventCancellation', $event)">
          Cancelacions
      </mat-checkbox>
    </p>
    <mat-divider *ngIf="calendarData.accessRole === 'owner'"></mat-divider>
  </mat-card-content>
  <mat-card-actions style="text-align: right;" *ngIf="calendarData.accessRole === 'owner'">
    <button mat-icon-button (click)="editCalendarData()">
      <mat-icon color="primary" style="font-size:24px">mode_edit</mat-icon>
    </button>
    <button mat-icon-button (click)="editCalendarData()">
      <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>

